import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import type { PartnerOrganizationAddress } from "./entity";

export const PartnerOrganizationAddressEntityConfig: HyperEntityConfig<PartnerOrganizationAddress> =
  {
    allowApiRead: true,
    allowApiCrud: Roles.SuperAdmins,

    apiPrefilterPerRole: (filter) => {
      if (!remult.user) return;

      filter(Roles.SuperDuperAdmin, true);
      filter(Roles.SuperAdmin, true);

      filter([Roles.Admin, Roles.Manager], {
        partnerOrganization: {
          $is: {
            organizationManagers: {
              $some: {
                managerId: remult.user?.id ?? "",
              },
            },
          },
        },
      });

      filter(Roles.User, {
        partnerOrganization: {
          $is: {
            managers: {
              $some: {
                id: remult.user?.id ?? "",
              },
            },
          },
        },
      });
    },

    allowInsertPerRole(allow) {
      allow(Roles.SuperAdmins, true);
    },

    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.SuperAdmins, true);
      allow(Roles.User, {
        partnerOrganization: {
          $is: {
            managers: {
              $some: {
                id: remult.user?.id ?? "",
              },
            },
          },
        },
      });
    },

    saving(entity) {
      const address = entity.address;
      if (address) {
        entity.address = String(address).trim();
      }
      const label = entity.label;
      if (!label || !String(label).trim()) {
        (entity as { label: string | null }).label = null;
      } else {
        entity.label = String(label).trim();
      }
    },
  };
